<template>
  <div
    :class="[
      'item-card',
      `is-${ics_type}`,
      { phone: $md.phone(), tablet: $md.tablet() },
    ]"
  >
    <span class="ics-tag">{{ icsTagText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    ics_type: {
      required: true,
      type: String,
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    icsTagText() {
      let output = '';
      switch (this.ics_type) {
        case 'i':
          output = this.$t('find.IND_SS');
          break;
        case 'c':
          output = this.$t('find.COMM_SS');
          break;
        case 's':
          output = this.$t('find.SHOP_SS');
          break;
        case 'ics':
          output = this.$t('find.ALL_SS');
          break;
        default:
          break;
      }
      return output;
    },
  },
};
</script>

<style scoped>
.item-card .ics-tag {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: #ffffff;
}

.item-card.is-ics .ics-tag {
  background: #FEE100;
  color: #000000;
}

.item-card.is-i .ics-tag {
  background: #47337C;
}

.item-card.is-c .ics-tag {
  background: #008cba;
}

.item-card.is-s .ics-tag {
  background: #da4e00;
}
</style>
